import React from 'react';
import { BadgeCheckIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="border-t border-line bg-panel px-4 py-16 sm:py-20" aria-label="Testimonials" data-id="element-297" data-mp="3fxun461bgqtd">
      <div className="mx-auto max-w-6xl" data-id="element-298" data-mp="3b0aycc6zsvn6">
        <SectionHeading kicker="What technicians are saying" title={<>
              Better organization. <span className="text-amber" data-id="element-300" data-mp="31z3bqrdu9j8x">Clearer evidence.</span> More consistent decisions.
            </>} data-id="element-299" data-mp="36zilza2tqamo" />

        <ul className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-301" data-mp="2x2w2aom8hpm8">
          {testimonials.map(t => <li key={t.name} className="flex flex-col rounded-2xl bg-panel2 p-6" data-id="element-302" data-mp="2s3t5frgeqppc">
              <div className="flex gap-1" aria-label="5 out of 5 stars" data-id="element-303" data-mp="v8ncpcxfipjo">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-amber text-amber" aria-hidden="true" data-id="element-304" data-mp="h5ya8j4cpl5q" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 text-[16px] leading-relaxed text-white" data-id="element-305" data-mp="m62nm09ypzrq">“{t.quote}”</blockquote>
              <div className="mt-auto flex items-center gap-4 pt-6" data-id="element-306" data-mp="7927ku14vt93">
                <img src={t.image} alt={t.name} className="h-16 w-16 shrink-0 rounded-full border-2 border-amber object-cover" loading="lazy" data-id="element-307" data-mp="c6bspxhhpir4" />
                <div data-id="element-308" data-mp="14u7q74evveoy">
                  <p className="flex items-center gap-1.5 font-bold text-white" data-id="element-309" data-mp="14xlre9bt9hut">
                    {t.name}
                    <BadgeCheckIcon className="h-4 w-4 text-ok" aria-label="Verified buyer" data-id="element-310" data-mp="q4sb4lopsxp3" />
                  </p>
                  <p className="text-sm text-mist" data-id="element-311" data-mp="1iva9j9ehuaw6">{t.role}</p>
                </div>
              </div>
            </li>)}
        </ul>

        <CtaButton className="mt-12" label="I want a structured process" sub="Join them for a one-time $27" data-id="element-312" data-mp="1nmsf6argoznh" />
      </div>
    </section>;
}